import { Injectable } from '@angular/core';
import { Student } from '.';
import { School } from '../school';

@Injectable()
export class StudentUtilService {
    public getStatusBadgeStyle(paidPercentage: number): string {
        if (paidPercentage > 80) {
            return 'badge-success';
        } else if (paidPercentage > 30) {
            return 'badge-warning';
        } else {
            return 'badge-danger';
        }

    }

    public getAuthorityBadgeStyle(authority: string): string {
        switch (authority) {
            case 'ROLE_SCHOOL_ADMIN':
                return 'badge-danger';
            case 'ROLE_ADVANCED_TEACHER':
                return 'badge-warning';
            case 'ROLE_TEACHER':
                return 'badge-info';
            default :
                return 'badge-success';
        }
    }

    public getBookingWindow(school: School, student: Student): number {
        if (!school || !student) {
            return 0;
        }
        return  school.bookingWindowByStudentEnabled  ?
        student.maxDaysToShowInLessonsLists : school.maxDaysToShowInLessonsLists;
    }

    public orderStudentsByName(students: Student[] ): Student[] {
            if (!students) {
                return students;
            }

            return students.sort( (a, b) =>  {
                const nameA = a.label.toUpperCase(); // ignore upper and lowercase
                const nameB = b.label.toUpperCase(); // ignore upper and lowercase
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                // names must be equal
                return 0;
            });
        }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/student/student.util.service.ts